import {getLoanAphStatusTextByValue} from "../LoanManagement/aphLoanUtility";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";

export const aphLoanHistoryItemModel = ({
                                            aphCatalogItem,
                                            aphCatalogItemId,
                                            aphLoanItemId,
                                            aphLoanNotes,
                                            aphLoanStatus,
                                            aphQueueItem,
                                            aphQueueItemId,
                                            dateCreatedUtc,
                                            dateFulfilledUtc,
                                            dateModifiedUtc,
                                            districtName,
                                            organization,
                                            patron,
                                            patronId,
                                            shippingLocation,
                                            shippingLocationId,
                                            student,
                                            studentId,
                                        }: Record<string, any> = {}) => ({
    aphCatalogItem,
    aphCatalogItemId,
    aphLoanItemId,
    aphLoanNotes: isNullOrUndefined(aphLoanNotes) ? "" : aphLoanNotes,
    aphLoanStatus,
    aphLoanStatusText: getLoanAphStatusTextByValue(aphLoanStatus),
    aphQueueItem,
    aphQueueItemId,
    dateCreatedUtc,
    dateFulfilledUtc,
    dateModifiedUtc,
    dateCreatedFormatted: convertDateToPrintString(dateCreatedUtc),
    dateFulfilledFormatted: dateFulfilledUtc ? convertDateToPrintString(dateFulfilledUtc) : "",
    dateModifiedFormatted: convertDateToPrintString(dateModifiedUtc),
    districtName: isNullOrUndefined(districtName) ? "" : districtName,
    organization: isNullOrUndefined(organization) ? "" : organization,
    patron,
    patronId,
    shippingLocation,
    shippingLocationId,
    student,
    studentId,
});

